<template>
  <div class="modal fade" id="infoPackageModal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true" ref="infoPackageModal">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header text-left">
          <button type="button" class="close" data-dismiss="modal"><span aria-hidden="true">&times;</span><span class="sr-only">Close</span></button>
          <h4 class="modal-title text-red" id="myModalLabel" style="font-size: 20px">
            套餐 - {{currentProduct[schema.product.name]}}
          </h4>
        </div>
        <div class="modal-body" v-if="currentProduct">
          <ul class="nav">
            <!-- 套餐組合 -->
            <li class="col-xs-12 p-x-0">
              <ul class="col-xs-12 nav">
                <li class="col-xs-12 p-x-0 line-style" v-show="packageLayer.show">
                  <div class="col-xs-12 p-x-0">
                    <p class="text-13 text-red"><i class="fa fa-star" aria-hidden="true"></i> 如更動套餐品項，需重新調整項目</p>
                  </div>
                  <div class="col-xs-12 p-x-0 order-item adjust" v-for="(node, nIndex) in bActiveList" v-if="currentProduct && checkDisableBlock(node.block.product[schema.block.product_id], currentProduct[schema.product.product_id])">
                    <h5>{{node.block.product[schema.block.name]}}
                      <span class="text-13" style="top: 0px" v-if="node.block.product[schema.block.min_limit] !== 1 && node.block.product[schema.block.min_limit] !== 0 &&
                      node.block.product[schema.block.max_limit] !== 1 && node.block.product[schema.block.max_limit] !== 0 && node.block.product[schema.block.min_limit] === node.block.product[schema.block.max_limit]">(以下必選{{node.block.product[schema.block.min_limit]}}項)</span>
                      <span class="text-13" style="top: 0px" v-else-if="node.block.product[schema.block.min_limit] !== 1 && node.block.product[schema.block.min_limit] !== 0 &&
                      node.block.product[schema.block.max_limit] !== 1 && node.block.product[schema.block.max_limit] !== 0">(可選擇{{node.block.product[schema.block.min_limit]}} ~ {{node.block.product[schema.block.max_limit]}}項)</span>
                      <span class="text-13" style="top: 0px" v-else-if="node.block.product[schema.block.min_limit] !== 1 && node.block.product[schema.block.min_limit] !== 0">(最少可選擇{{node.block.product[schema.block.min_limit]}}項)</span>
                      <span class="text-13" style="top: 0px" v-else-if="node.block.product[schema.block.max_limit] !== 1 && node.block.product[schema.block.max_limit] !== 0">(最多可選擇{{node.block.product[schema.block.max_limit]}})</span>
                    </h5>
                    <!-- 套餐組和 (選取區塊) -->
                    <div class="inline-block choose-block c-pointer" @click="clickBlock(parseInt(node2.product[schema.product.product_id], 10), node)"
                         :prodActive = "node2.active && checkDisableItem(node2.product[schema.product.product_id], node.block.product[schema.block.product_id])"
                         v-for="(node2, n2Index) in sortObj(node.prod)"
                         :disabled="!checkDisableItem(node2.product[schema.product.product_id], node.block.product[schema.block.product_id])"
                    >
                      <span class="text-red text-14" v-if="node2.product[schema.product.is_mandatory]">* </span>
                      {{node2.product[schema.product.name]}}
                      <div class="label option-number" v-if="optionNumList[0][node2.product[schema.product.product_id]] && optionNumList[0][node2.product[schema.product.product_id]] !== 1">
                        {{optionNumList[0][node2.product[schema.product.product_id]]}}
                      </div>
                      <div class="label option-number" v-else-if="optionNumList[0][node2.product[schema.product.product_id]] && optionNumList[0][node2.product[schema.product.product_id]] === 1 && node2.product[schema.product.max_limit] !== 1">
                        {{optionNumList[0][node2.product[schema.product.product_id]]}}
                      </div>
                    </div>
                    <hr class="m-y-0" style="top: 5px" v-if="nIndex < bActiveList.length - 1 || otherActiveList.length">
                  </div>
                  <div class="col-xs-12 p-x-0 order-item adjust" v-if="currentProduct && otherActiveList.length">
                    <h6 class="">副餐</h6>
                    <!-- 套餐組和 (選取區塊) -->
                    <div class="inline-block choose-block c-pointer"
                         :prodActive = "p.active"
                         v-for="(p, pIndex) in otherActiveList"
                         @click="clickOtherP(parseInt(p.id, 10), p)"
                    >
                      <span class="text-pin text-14" v-if="getProduct(p.id)[schema.product.is_mandatory]">* </span>
                      {{getProduct(p.id)[schema.product.name]}}
                      <!--{{p.product[schema.product.name]}} {{p.product[schema.product.product_id]}}-->
                    </div>
                  </div>
                </li>
                <!--
                <li class="col-xs-12 p-x-0"  v-show="!packageLayer.show">
                  <p class="text-red m-t-5">
                    <i class="fa fa-star" aria-hidden="true"></i> 如更動組合，需重新調整商品內容
                  </p>
                </li>
                -->
              </ul>
              <ul class="col-xs-12 nav" style="padding-top: 6px">
                <li class="col-xs-12 p-x-0">
                  <div class="col-xs-12 p-x-0 order-item adjust">
                    <div class="col-xs-12 p-x-0 form-title" style="margin-top: 0px">
                      已選取商品
                    </div>
                    <div class="col-xs-12 p-10" style="background: #f4f4f4; border: 3px dashed #eee; border-top: 0px; border-radius: 0px 0px 6px 6px">
                      <!-- 商品內容 (選取商品) -->
                      <div class="inline-block choose-block c-pointer" v-if="pShow(pc)"
                           v-for="(pc, pcIndex) in getProductContainer"
                           @click="clickProduct(pc)"
                           :prodActive = "curProduct(pc)"
                           style="border-radius: 20px"
                      >
                        <span class="text-red text-14" v-if="pc[schema.product.is_mandatory]">* </span>
                        {{pc[schema.product.name]}}
                        <div class="label option-number" v-if="optionNumList[0][pc[schema.product.product_id]] && optionNumList[0][pc[schema.product.product_id]] !== 1">
                          {{optionNumList[0][pc[schema.product.product_id]]}}
                        </div>
                      </div>
                      <br>
                      <div class="pull-right inline-block choose-block c-pointer bg-pink text-white m-t-20 text-w-600" @click="clickChoseP" v-if="!packageLayer.show" style="margin-right: 0px">
                        <i class="fa fa-caret-left" aria-hidden="true"></i>&nbsp;步驟一 - 變更套餐內容
                      </div>
                      <div class="pull-right inline-block choose-block c-pointer bg-pink text-white m-t-20 text-w-600" @click="clickChangeOption" v-else style="margin-right: 0px">
                        步驟二 - 調整商品細節&nbsp;<i class="fa fa-caret-right" aria-hidden="true"></i>
                      </div>
                    </div>
                  </div>
                </li>
                <li class="col-xs-12 p-x-0 line-style" v-show="!packageLayer.show && pShow(pcDetail) && curProduct(pcDetail)" v-for="(pcDetail, pIndex) in getProductContainer" v-if="allProduct[pcDetail[schema.product.product_id]]">
                  <muti-prod :storeState="2"
                             :modalView="modalView"
                             :currentProduct="pcDetail"
                             :brandId="brandId"
                             prodType="package"
                             :checkPrice="checkPrice"
                             :checkAddProduct="checkAddProduct"
                             :checkAddDifProduct="checkAddDifProduct"
                             :productAmount="getPAmount(pcDetail)"
                             :optionCheck="optionCheck"
                             :ref="'menu-options-' + pcDetail[schema.product.product_id]"
                             :show="show"
                             :productShow="pShow(pcDetail)"
                             :adjustSame="adjustSame"
                             :menuJson="menuJson"
                             :clickProduct="clickProduct"
                  ></muti-prod>
                  <!--
                             :showProductIcon="showProductIcon"
                             :getIcon="getIcon"
                             :iconList="iconList"
                             :pIconList="pIconList"
                             :picLength="getSubImages(currentProduct[0]).length"
                  -->
                  <p class="text-red text-14" v-if="cheeseWording(pcDetail[schema.product.name])"><br>★ 此產品已含起司，請斟酌加購起司</p>
                </li>
              </ul>
            </li>
            <!-- 套餐組合結束 -->
            <li class="col-xs-12 p-x-0" v-if="adjusts.length">
              <hr style="margin: 15px 0px 0px 0px">
            </li>
          </ul>

          <ul class="nav">
            <li class="col-xs-12 p-x-0 order-item m-t-15 p-5">
              <p>總金額：{{totalPrice()}} 元</p>
              <div class="q-numeric textfield row inline items-center input-number m-x-0 col-xs-12">
                <div class="input-group">
                    <span class="input-group-addon numeric-left c-pointer bg-pink"  @click="number--">
                      -
                    </span>
                  <input type="tel" pattern="[0-9]*" tabindex="0" step="1" min="1" max="99" class="no-style auto q-input-field inline-block text-center" maxlength="2" v-model="number">
                  <span class="input-group-addon numeric-right  c-pointer bg-pink" @click="number++">
                      +
                    </span>
                </div>
              </div>
            </li>
          </ul>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-default" data-dismiss="modal">關閉</button>
          <button type="button" class="btn btn-success" @click="clickAdd">測試</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import parse from '../../../../assets/js/parse-menu.js'
import menuOptions from './MenuOptions.vue'
import $ from 'jquery'
import MutiProduct from './MutiProduct.vue'
export default{
  components: {
    'menu-options': menuOptions,
    'muti-prod': MutiProduct
  },
  props: {
    modalView: {
      type: Boolean
    },
    currentProduct: {
      type: [Array]
    },
    brandId: {
      type: Number
    },
    menuJson: {
      type: [Object, String]
    }
  },
  data () {
    return {
      isVisible: [],
      tags: 0,
      isOption: [],
      isShow: [],
      cartMount: 0,
      totalPrice () {
        return parseInt(this.number, 10) * this.price
      },
      combineId: '',
      adjusts: [],
      schema: {
        category: {},
        product: {},
        icon: {},
        image: {},
        tag: {},
        adjust: {},
        option: {},
        combine: {},
        edge: {},
        common: {},
        block: {}
      },
      currentMenuJson: '',
      storeId: this.$route.params.storeId,
      productCombineIds: [],
      menu: {
        categoryList: {},
        productList: {},
        adjustList: {},
        optionList: {},
        combineList: {}
      },
      show: {
        reChoose: false,
        picDetail: false
      },
      swiperOption: {
        autoplay: 4000,
        setWrapperSize: true,
        pagination: '.img-pagination',
        paginationClickable: true,
        // mousewheelControl: true,
        observeParents: true,
        prevButton: '.img-button-prev',
        nextButton: '.img-button-next',
        loop: true,
        paginationElement: 'li'
      },
      number: 1,
      price: 0,
      // option 條列式
      optionStyle: false,
      // 套餐區塊
      packageLayer: {
        show: true
      },
      // 套餐組合區
      bActiveList: [],
      otherActiveList: [], // 其他副餐
      // 商品內容區
      pActiveList: [],
      allProduct: {},
      // 菜單層數超過2
      errorMenu: false,
      // 欲修改的product
      choseCurProd: 0,
      // 套餐加料金額與內容
      addPrice: {},
      addPrices: {}, // 此為商品如果選了三個(又要不同調整項目時)
      addDetail: {},
      addDetails: {}, // 此為商品如果選了三個(又要不同調整項目時)
      addAdjust: {},
      // 查看option選擇後價格
      optionCheck: {
        id: 0,
        num: 0
      },
      // block所選項數量
      optionNum: {},
      optionNumList: [{}],
      // 是否調整項目相同
      adjustSame: {},
      checkTest: true
    }
  },
  methods: {
    sortObj (obj) {
      var pSchema = this.schema.product
      var newO = Object.values(obj).sort(function (a, b) {
        return a.product[pSchema.sort] - b.product[pSchema.sort]
      })
      // console.log(newO)
      return newO
    },
    sortProd (array) {
      var newA = array.sort(function (a, b) {
        return a.sort - b.sort
      })
      // console.log(newO)
      return newA
    },
    pShow (product) {
      var pSchema = this.schema.product
      var pId = product[pSchema.product_id]
      var show = this.pActiveList.find(function (o) {
        if (pId === o.id) {
          if (o.show) return true
          else return false
        }
      })
      return show
    },
    adjustsOfProduct (productId) {
      return this.getProduct(productId)[this.schema.product.adjust_list]
    },
    optionsOfAdjust (adjustId) {
      return this.getAdjust(adjustId)[this.schema.adjust.option_list]
    },
    combinesOfProduct (productId) {
      return this.getProduct(productId)[this.schema.product.combine_list]
    },
    getProduct (productId) {
      return this.menu.productList[productId]
    },
    getAdjust (adjustId) {
      return this.menu.adjustList[adjustId]
    },
    getOption (optionId) {
      return this.menu.optionList[optionId]
    },
    getCombine (combineId) {
      return this.menu.combineList[combineId]
    },
    getBlock (blockId) {
      return this.menu.blockList[blockId]
    },
    getPAmount (prod) {
      var pSchema = this.schema.product
      var pId = prod[pSchema.product_id]
      if (!this.getModalView) return 1
      else if (this.optionNumList[0][pId]) return this.optionNumList[0][pId]
      else return 1
    },
    clickChoseP () {
      this.choseCurProd = 0
      this.packageLayer.show = true
    },
    clickAdd () {
      // this.setBtnDis(true)
      var self = this
      var mandatoryLack = false
      var bSchema = this.schema.block
      for (var b = 0; b < this.bActiveList.length; b++) {
        var block = this.bActiveList[b]
        if (block.block.product[bSchema.is_mandatory]) {
          if (block.activeList.length < block[bSchema.min_limit] || !block.activeList.length) {
            /*
            Toast.create.negative({
              html: block.block.product[bSchema.name] + '未選',
              timeout: 2500
            })
            */
            self.$notify({
              title: '提醒',
              text: block.block.product[bSchema.name] + '未選',
              duration: 2500,
              type: 'danger'
            })
            self.clickChoseP()
            mandatoryLack = true
            break
          }
        }
        if (block.block.product[bSchema.min_limit] && block.block.product[bSchema.min_limit] > block.activeList.length) {
          /*
          Toast.create.negative({
            html: block.block.product[bSchema.name] + '未選' + block.block.product[bSchema.min_limit] + '項',
            timeout: 2500
          })
          */
          self.$notify({
            title: '提醒',
            text: block.block.product[bSchema.name] + '未選' + block.block.product[bSchema.min_limit] + '項',
            duration: 2500,
            type: 'danger'
          })
          self.clickChoseP()
          mandatoryLack = true
          break
        }
        if (b === this.bActiveList.length - 1) this.checkPActive(mandatoryLack)
      }
    },
    checkPActive (mandatoryLack) {
      for (var p = 0; p < this.pActiveList.length; p++) {
        var pA = this.pActiveList[p]
        if (pA.show) {
          if (!this.$refs['menu-options-' + pA.id][0].clickAdd()) {
            mandatoryLack = true
            break
          }
        }
        if (p === this.pActiveList.length - 1) this.checkError(mandatoryLack)
      }
    },
    checkError (mandatoryLack) {
      if (!mandatoryLack) {
        this.$notify({
          title: '成功',
          text: '成功加入商品',
          duration: 2500,
          type: 'success'
        })
      }
    },
    parsePrice (product) {
      // Schema
      const pSchema = this.schema.product
      const aSchema = this.schema.adjust
      const oSchema = this.schema.option
      var productId = product[pSchema.product_id]
      var price
      var type
      var checkP = this.getProduct(productId)
      var checkA = this.getAdjust(productId)
      var checkO = this.getOption(productId)
      var isOption = []
      var minPrice = []
      if (checkP) {
        // console.log(checkP)
        price = checkP[pSchema.price]
        type = 'p'
        var aList = checkP[pSchema.adjust_list]
        aList = parse.divideList(aList, this.getAdjust)
        for (var j = 0; j < aList.length; j++) {
          var aListPrice = []
          var tag = 0
          for (var k = 0; k < aList[j][aSchema.option_list].length; k++) {
            tag++
            aListPrice.push(aList[j][aSchema.option_list][k][oSchema.price])
            if (tag === aList[j][aSchema.option_list].length) minPrice.push(Math.min.apply(Math, aListPrice))
          }
        }
        for (var m = 0; m < aList.length; m++) {
          // var min = aList[j][aSchema.min_limit]
          var max = aList[m][aSchema.max_limit]
          var tags = 1
          for (var n = 0; n < aList[m][aSchema.option_list].length; n++) {
            if (aList[m][aSchema.option_list][n][oSchema.price] === minPrice[m] && tags <= max) {
              tags++
              if (aList[m][aSchema.is_mandatory]) isOption.push({adjust: aList[m], option: aList[m][aSchema.option_list][n]})
            }
          }
        }
        // console.log(isOption)
      } else if (checkA) {
        // console.log(checkA)
        price = checkA[aSchema.price]
        type = 'a'
        if (price === null) {
          for (var i = 0; i < checkA[aSchema.option_list].length; i++) {
            if (checkA[aSchema.option_list][i][oSchema.is_mandatory]) {
              price = price + checkA[aSchema.option_list][i][oSchema.price]
            }
          }
        }
      } else if (checkO) {
        // console.log(checkO)
        price = checkO[oSchema.price]
        type = 'o'
      }
      if (isOption.length) this.isOption = isOption
      return {price: price, type: type}
    },
    showAll (product, combines) {
      // Schema
      const pSchema = this.schema.product
      const aSchema = this.schema.adjust
      const oSchema = this.schema.option

      // Data
      var adjustIds = product[pSchema.adjust_list]
      var result = []

      // Fill Up adjust.option_list with option
      for (var adjustIndex = 0; adjustIndex < adjustIds.length; adjustIndex++) {
        var adjust = parse.divideList(adjustIds, this.getAdjust)[adjustIndex]
        if (adjust) {
          adjust.activeCount = 0
          adjust.activeOptionIds = []
          for (var optionIndex = 0; optionIndex < adjust[aSchema.option_list].length; optionIndex++) {
            if (typeof adjust[aSchema.option_list][optionIndex] === 'number') {
              adjust[aSchema.option_list][optionIndex] = this.getOption(adjust[aSchema.option_list][optionIndex])
              adjust[aSchema.option_list][optionIndex].activeCount = 0
            }
          }
          adjust[aSchema.option_list].sort(function (a, b) {
            if (a[oSchema.sort] > b[oSchema.sort]) {
              return 1
            }
            if (a[oSchema.sort] < b[oSchema.sort]) {
              return -1
            }

            return 0
          })
          result.push(adjust)
        }
      }
      // 排adjust順序 (尺寸, 甜度, 溫度, 加料)
      result.push([])
      result.sort(function (a, b) {
        if (a[aSchema.sub_type] && b[aSchema.sub_type]) return b[aSchema.sub_type] - a[aSchema.sub_type]
        else return b[aSchema.sub_type] - a[aSchema.sub_type]
      })
      result.splice(-1, 1)
      return result
    },
    filterCombine (combines) {
      //  Schema
      const oSchema = this.schema.option
      const cSchema = this.schema.combine
      const eSchema = this.schema.edge
      const aSchema = this.schema.adjust
      this.isShow = []

      // filter combination
      $('.btn-option').css('display', 'none')
      var combine = parse.divideList(combines, this.getCombine)
      for (var cIndex = 0; cIndex < combine.length; cIndex++) {
        for (var oIndex in combine[cIndex][cSchema.edge_list]) {
          this.isShow.push(combine[cIndex][cSchema.edge_list][oIndex][eSchema.product_id])
        }
      }
      this.isShow = this.isShow.filter(function (elem, index, self) {
        return self.indexOf(elem) === index
      })
      for (var id = 0; id < this.isShow.length; id++) {
        var num = this.isShow[id]
        if (this.getOption(num)) {
          // show
          $('#option-' + this.getOption(num)[oSchema.product_id]).css('display', 'inline-block')
        } else if (this.getAdjust(num)) {
          // show
          var options = this.getAdjust(num)[aSchema.option_list]
          for (var o = 0; o < options.length; o++) {
            $('#option-' + options[o][oSchema.product_id]).css('display', 'inline-block')
          }
        }
      }
    },
    createMapping (arrayData, idIndex) {
      var mapping = {}
      for (var i = 0; i < arrayData.length; i++) {
        mapping[arrayData[i][idIndex]] = i
      }

      return mapping
    },
    createOptionMapping (adjusts) {
      // Schema
      const aSchema = this.schema.adjust
      const oSchema = this.schema.option

      // Data
      var mapping = {}
      for (var i = 0; i < adjusts.length; i++) {
        for (var j = 0; j < adjusts[i][aSchema.option_list].length; j++) {
          mapping[adjusts[i][aSchema.option_list][j][oSchema.product_id]] = {
            adjustIndex: i,
            optionIndex: j
          }
        }
      }

      return mapping
    },
    search (id, adjusts, productId) {
      var result = []
      var aSchema = this.schema.adjust
      // var product = this.getProduct(id)
      var adjust = this.getAdjust(id)
      var option = this.getOption(id)
      if (option) {
        result.push(option)
        return result
        // if edge is option
      } else {
        if (adjust) {
          // result.push(adjust)
          option = parse.divideList(adjust[aSchema.option_list], this.getOption)
          for (var i = 0; i < option.length; i++) {
            result.push(option[i])
          }

          /*
          result[1].sort(function (a, b) {
            return b[7] - a[7]
          })
          */
          return result
        }
        /*
        else {
          if (product) {
            // if edge product
            result.push(product)
            return result
          }
        }
        */
      }
      /*
      for (var i = 0; i < adjusts.length; i++) {
        if (id === adjusts[i]) {
          result.push(id)
        }
      }
      */
    },
    clickOption (clickedOption, clickedOptionIndex, clickedAdjust, clickedAdjustIndex) {
      // Schema
      const pSchema = this.schema.product
      const aSchema = this.schema.adjust
      const oSchema = this.schema.option
      // const cSchema = this.schema.combine

      // Disable Animation
      $('#option-' + clickedOption[oSchema.product_id]).unbind('mouseenter mouseleave')

      // Data
      // 0.
      var clickedAdjustId = clickedAdjust[aSchema.product_id]
      var clickedOptionId = clickedOption[oSchema.product_id]
      var productAdjustIds = this.currentProduct[pSchema.adjust_list]
      // var productCombineIds = this.currentProduct[pSchema.combine_list]
      var adjustIndex = 0
      var adjust = null
      // var optionIndex = 0
      var option = null
      var blockedOptionIds = []
      var bOptionId

      // Add All mandatory Class on Click
      for (adjustIndex = 0; adjustIndex < productAdjustIds.length; adjustIndex++) {
        adjust = this.getAdjust(productAdjustIds[adjustIndex])
        if (adjust[aSchema.is_mandatory] === true) {
          $('.adjust-' + productAdjustIds[adjustIndex]).addClass('mandatory')
        }
      }

      // Click Flow
      // 1. 假如是取消點選(此處定義為取消點選全部，亦即該 Option 有同樣的三份，就是這三個都取消)
      if ($('#option-' + clickedOptionId).attr('active')) {
        this.removeArray(clickedAdjust.activeOptionIds, clickedOptionId)
        clickedAdjust.activeCount -= clickedOption.activeCount
        clickedOption.activeCount = 0
        $('#option-' + clickedOptionId).removeAttr('active', false)
        $('#option-' + clickedOptionId).removeClass('active')
        for (adjust of this.adjusts) {
          $('.adjust-' + adjust[aSchema.product_id] + ' div').removeClass('btn-blocked')
        }

        var passCombinations = this.ruleValidation()
        blockedOptionIds = this.getBlockedOptionIds(passCombinations)
        for (bOptionId of blockedOptionIds) {
          $('#option-' + bOptionId).addClass('btn-blocked')
        }
        this.price = this.calculatePriceBySelectedOptions(passCombinations)

        return
      }

      // 2. 選取並檢查是否超過此 Option 上限
      clickedAdjust.activeOptionIds.push(clickedOptionId)
      clickedAdjust.activeCount++
      clickedOption.activeCount++
      $('#option-' + clickedOptionId).attr('active', true)
      // if(clickedOption.activeCount > clickedOption[aSchema.max_limit]) {
      //   Toast.create.negative({
      //     html: '此選項最多只能加' + clickedOption[oSchema.max_limit] + '份喔！',
      //     timeout: 2500
      //   })
      // }

      // 3. 如果規則驗證失敗就全部重來
      passCombinations = this.ruleValidation()
      if (passCombinations.length === 0) {
        // Remove
        for (adjust of this.adjusts) {
          adjust.activeOptionIds = []
          adjust.activeCount = 0
          for (option of adjust[aSchema.option_list]) {
            option.activeCount = 0
          }
          $('.adjust-' + adjust[aSchema.product_id] + ' div').removeAttr('active')
          $('.adjust-' + adjust[aSchema.product_id] + ' div').removeClass('active')
          $('.adjust-' + adjust[aSchema.product_id] + ' div').removeClass('btn-blocked')
        }
        // Then Add
        clickedAdjust.activeOptionIds.push(clickedOptionId)
        clickedAdjust.activeCount = 1
        clickedOption.activeCount = 1
        $('#option-' + clickedOptionId).attr('active', true)
      }

      // 4. 超過這個 Adjust 上限，這個 Adjust 全部重來
      if (clickedAdjust.activeCount > clickedAdjust[aSchema.max_limit] && clickedAdjust[aSchema.max_limit]) {
        // Remove
        clickedAdjust.activeOptionIds = []
        clickedAdjust.activeCount = 0
        for (option of clickedAdjust[aSchema.option_list]) {
          option.activeCount = 0
        }
        $('.adjust-' + clickedAdjustId + ' div').removeAttr('active')
        $('.adjust-' + clickedAdjustId + ' div').removeClass('active')
        for (adjust of this.adjusts) {
          $('.adjust-' + adjust[aSchema.product_id] + ' div').removeClass('btn-blocked')
        }
        // Then Add
        clickedAdjust.activeOptionIds.push(clickedOptionId)
        clickedAdjust.activeCount = 1
        clickedOption.activeCount = 1
        $('#option-' + clickedOptionId).attr('active', true)

        // Toast.create.negative({
        //   html: clickedAdjust[aSchema.name] + '只能選 ' + clickedAdjust[aSchema.max_limit] + ' 種喔！',
        //   timeout: 2500
        // })
      }

      // 5.
      passCombinations = this.ruleValidation()
      blockedOptionIds = this.getBlockedOptionIds(passCombinations)
      for (bOptionId of blockedOptionIds) {
        $('#option-' + bOptionId).addClass('btn-blocked')
      }
      this.price = this.calculatePriceBySelectedOptions(passCombinations)
    },
    // 規則驗證
    ruleValidation () {
      // Schema
      const aSchema = this.schema.adjust
      const oSchema = this.schema.option
      const cSchema = this.schema.combine
      const eSchema = this.schema.edge

      // 使用所有已經選取的 Options 篩選出 Combinations constrainCombList
      var constrainCombList = []
      var adjust = null
      var option = null
      var combineId = null
      var combine = null
      var edge = null
      var isExist = false
      // 把 combination 分開來檢查
      for (combineId of this.productCombineIds) {
        combine = this.menu.combineList[combineId]
        // 掃描所有已經選取的 Options，看看是不是全部都在這個 combination 下
        var allInGraph = true
        for (adjust of this.adjusts) {
          for (option of adjust[aSchema.option_list]) {
            if (option.activeCount > 0) {
              //
              isExist = false
              for (var edgeId in combine[cSchema.edge_list]) {
                edge = combine[cSchema.edge_list][edgeId]
                switch (edge[eSchema.product_type]) {
                  // Option = 2
                  case 2:
                    if (edge[eSchema.product_id] === option[oSchema.product_id]) {
                      isExist = true
                    }
                    break
                  // Adjust = 20
                  case 20:
                    if (edge[eSchema.product_id] === adjust[aSchema.product_id]) {
                      isExist = true
                    }
                    break
                }
                if (isExist) {
                  break
                }
              }
              if (!isExist) {
                allInGraph = false
                break
              }
            }
          }
          if (!allInGraph) {
            break
          }
        }
        if (allInGraph) {
          constrainCombList.push(combine)
        }
      }

      return constrainCombList
    },
    // 取得禁選的 Option IDs
    getBlockedOptionIds (constrainCombList) {
      // Schema
      const aSchema = this.schema.adjust
      const oSchema = this.schema.option
      const cSchema = this.schema.combine
      const eSchema = this.schema.edge

      // 使用所有已經選取的 Options 篩選出 Combinations constrainCombList
      var blockedOptionIds = []
      var adjust = null
      var option = null
      var combine = null
      var edge = null
      var edgeId = null
      var isExist = false

      // 找出不在 constrainCombList 中的 Options
      for (adjust of this.adjusts) {
        for (option of adjust[aSchema.option_list]) {
          //
          isExist = false
          for (combine of constrainCombList) {
            for (edgeId in combine[cSchema.edge_list]) {
              edge = combine[cSchema.edge_list][edgeId]
              switch (edge[eSchema.product_type]) {
                // Option = 2
                case 2:
                  if (edge[eSchema.product_id] === option[oSchema.product_id]) {
                    isExist = true
                  }
                  break
                // Adjust = 20
                case 20:
                  if (edge[eSchema.product_id] === adjust[aSchema.product_id]) {
                    isExist = true
                  }
                  break
              }
              if (isExist) {
                break
              }
            }
            if (isExist) {
              break
            }
          }
          if (!isExist) {
            blockedOptionIds.push(option[oSchema.product_id])
          }
        }
      }

      return blockedOptionIds
    },
    calculatePriceBySelectedOptions (constrainCombList) {
      // Schema
      const pSchema = this.schema.product
      const aSchema = this.schema.adjust
      const oSchema = this.schema.option
      const cSchema = this.schema.combine
      const eSchema = this.schema.edge

      // Data
      var minPrice = 0
      var maxCombineId = 0
      var maxPrice = 0
      var adjustIndex = null
      var adjust = null
      var optionMapping = null
      var option = null

      // Logic
      for (var combine of constrainCombList) {
        var price = 0
        if (combine[cSchema.price] !== null) {
          price = combine[cSchema.price]
          if (price < minPrice) {
            minPrice = price
          }
          if (price > maxPrice) {
            maxPrice = price
            maxCombineId = combine[cSchema.combine_id]
          }
          continue
        }
        for (var edgeId in combine[cSchema.edge_list]) {
          var edge = combine[cSchema.edge_list][edgeId]
          switch (edge[eSchema.product_type]) {
            // Product = 1
            case 1:
              price += this.getProduct(edge[eSchema.product_id])[pSchema.price]
              break
            // Option = 2
            case 2:
              optionMapping = this.optionsIndexMapping[edge[eSchema.product_id]]
              option = this.adjusts[optionMapping.adjustIndex][aSchema.option_list][optionMapping.optionIndex]
              if (option.activeCount > 0) {
                if (edge[eSchema.price] === null) {
                  price += (Number(option[oSchema.price]) * option.activeCount)
                } else {
                  price += (edge[eSchema.price] * option.activeCount)
                }
              }
              break
            // Adjust = 20
            case 20:
              // 這個 case 要考慮三件事情，「edge」、「adjust」、「option 的加總」
              adjustIndex = this.adjustsIndexMapping[edge[eSchema.product_id]]
              adjust = this.adjusts[adjustIndex]
              var isActiveAdjust = false
              var adjustPrice = 0
              for (option of adjust[aSchema.option_list]) {
                if (option.activeCount > 0) {
                  isActiveAdjust = true
                  adjustPrice += (option[oSchema.price] * option.activeCount)
                }
              }
              if (isActiveAdjust) {
                if (edge[eSchema.price] !== null) {
                  price += edge[eSchema.price]
                } else if (adjust[aSchema.price] !== null) {
                  price += adjust[aSchema.price]
                } else {
                  price += adjustPrice
                }
              }
              break
          }
        }
        if (price < minPrice) {
          minPrice = price
        }
        if (price > maxPrice) {
          maxPrice = price
          maxCombineId = combine[cSchema.combine_id]
        }
      } // end_of_constrainCombList

      this.combineId = maxCombineId
      return maxPrice
    },
    getSessionName (type, storeId) {
      if (type === 'version') {
        return 'Nidin_' + storeId + '_menuVersion'
      } else if (type === 'menu') {
        return 'Nidin_' + storeId + '_menu'
      } else {
        return false
      }
    },
    removeArray (arr, value) {
      var index = arr.indexOf(value)
      if (index > -1) {
        arr.splice(index, 1)
      }
    },
    checkPrice (price, product, pIndex) {
      var pSchema = this.schema.product
      // var pId = 0
      var newPrice = this.currentProduct[pSchema.price]
      if (product) {
        this.addPrice[product[pSchema.product_id]] = price
        // pId = product[pSchema.product_id]
      }
      if (pIndex && product) {
        if (!this.addPrices[product[pSchema.product_id]]) this.addPrices[product[pSchema.product_id]] = {}
        this.addPrices[product[pSchema.product_id]][pIndex] = price
      }
      for (var key in this.addPrice) {
        var num = 1
        if (this.optionNumList[0][key]) num = this.optionNumList[0][key]
        if (this.adjustSame[key]) {
          newPrice = newPrice + this.addPrice[key] * num
        }
      }
      for (var key2 in this.addPrices) {
        if (!this.adjustSame[key2]) {
          for (var pIndex2 in this.addPrices[key2]) {
            newPrice = newPrice + this.addPrices[key2][pIndex2] * 1 // 數量只有1
          }
        }
      }
      this.price = newPrice
    },
    checkAddProduct (item) {
      if (item.items[0].product_id) {
        this.addDetail[item.items[0].product_id] = item
      }
    },
    checkAddDifProduct (item, pIndex) {
      if (item.items[0].product_id) {
        if (!this.addDetails[item.items[0].product_id]) this.addDetails[item.items[0].product_id] = {}
        if (pIndex) {
          this.addDetails[item.items[0].product_id][pIndex] = item
        }
      }
    },
    init () {
      if (this.menuJson !== undefined) {
        this.currentMenuJson = this.menuJson
        // this.orderInfo.version = parseInt(window.localStorage[this.getSessionName('version', parseInt(this.$route.params.storeId, 10))], 10)
        this.menu.categoryList = this.currentMenuJson.category_list_json.data
        this.menu.productList = this.currentMenuJson.product_list_json.data
        this.menu.adjustList = this.currentMenuJson.adjust_list_json.data
        this.menu.optionList = this.currentMenuJson.option_list_json.data
        this.menu.combineList = this.currentMenuJson.combine_list_json.data
        if (this.currentMenuJson.block_list_json) this.menu.blockList = this.currentMenuJson.block_list_json.data

        this.schema.category = this.currentMenuJson.category_list_json.schema
        this.schema.product = this.currentMenuJson.product_list_json.schema
        this.schema.icon = this.currentMenuJson.product_list_json.icon_schema
        this.schema.img = this.currentMenuJson.product_list_json.img_schema
        this.schema.tag = this.currentMenuJson.product_list_json.tag_schema
        this.schema.adjust = this.currentMenuJson.adjust_list_json.schema
        this.schema.option = this.currentMenuJson.option_list_json.schema
        this.schema.combine = this.currentMenuJson.combine_list_json.schema
        this.schema.edge = this.currentMenuJson.combine_list_json.edge_schema
        this.schema.common = this.currentMenuJson.combine_list_json.common_schema
        if (this.currentMenuJson.block_list_json) this.schema.block = this.currentMenuJson.block_list_json.schema
        this.productContainer = []
      }
      this.initOptions()
    },
    clearOption () {
      // Schema
      var aSchema = this.schema.adjust
      var pSchema = this.schema.product

      // Clear Tmp Data
      this.limitList = {}
      for (var adjust of this.adjusts) {
        adjust.activeOptionIds = []
        adjust.activeCount = 0
        for (var option of adjust[aSchema.option_list]) {
          option.activeCount = 0
        }
      }

      this.number = 1
      // this.setBtnDis(false)
      this.price = this.currentProduct[pSchema.price]
      this.optionNum = {}
      this.optionNumList = [{}]
      this.choseCurProd = 0
      this.show.cantOrder = false
    },
    initOptions () {
      var pSchema = this.schema.product
      var cSchema = this.schema.combine
      // this.setBtnDis(false)
      // this.price = this.minPrice
      this.price = this.currentProduct[pSchema.price]
      this.combineId = this.currentProduct[pSchema.combine_list][cSchema.combine_id]
      this.productCombineIds = this.currentProduct[this.schema.product.combine_list]
      // this.adjusts = this.showAll(this.currentProduct, this.productCombineIds)
      this.adjustsIndexMapping = this.createMapping(this.adjusts, this.schema.adjust.product_id)
      this.optionsIndexMapping = this.createOptionMapping(this.adjusts)
      this.packageLayer = {
        show: true
      }
      this.productLayer = {
        show: false
      }
      this.productContainer = []
      // 套餐組合區
      this.bActiveList = []
      this.otherActiveList = []
      // 商品內容區
      this.pActiveList = []
      // 菜單層數超過2
      this.errorMenu = false
      // 欲修改的product
      this.choseCurProd = 0
      // 套餐加料金額與內容
      this.addPrice = {}
      this.addPrices = {}
      this.addDetail = {}
      this.addDetails = {}
      this.addAdjust = {}
      // 查看option選擇後價格
      this.optionCheck.id = 0
      this.allProduct = {}
      this.clearOption()
      this.$nextTick(function () {
        // this.filterCombine(this.productCombineIds)
        // this.orderInfo.menuId = window.sessionStorage[config.menuId]
        // show default option
        /*
        for (var j = 0; j < this.isOption.length; j++) {
          var option = this.isOption[j].option
          var adjust = this.isOption[j].adjust
          self.clickOption(option, 0, adjust, 0)
        }
        */
      })
    },
    checkAdjustDis (aId) {
      // console.log(this.disAdjust)
      // console.log(aId)
      var dis = this.disAdjust.find(function (o) { return o === aId })
      if (dis) {
        return false
      } else return true
    },
    checkOptionDis (oId, aId) {
      // console.log(this.disOption)
      // console.log(oId, aId)
      if (this.disOption[aId]) {
        var dis = this.disOption[aId].find(function (o) { return o.product_id === oId })
        if (dis) {
          return false
        } else return true
      } else {
        return true
      }
    },
    getSubImages (pId) {
      if (this.prodImgList[pId]) return this.prodImgList[pId].sub_image_list
      return []
    },
    checkDisableItem (itemId, blockId) {
      if (typeof this.disItem !== 'undefined') {
        var pBDis = this.disItem[blockId]
        if (pBDis) {
          var pDis = this.disItem[blockId].find(function (o) {
            return o.product_id === itemId
          })
          if (pDis) return false
        }
        return true
      }
      return true
    },
    checkDisableBlock (blockId, packageId) {
      if (typeof this.disBlock !== 'undefined') {
        var bPDis = this.disBlock[packageId]
        if (bPDis) {
          var bDis = this.disBlock[packageId].find(function (o) {
            return o.product_id === blockId
          })
          if (bDis) return false
        }
        return true
      }
      return true
    },
    clickChangeOption () {
      var prodId = this.pActiveList.find(function (o) {
        if (o.show) return o
      }).id
      this.clickProduct(this.getProduct(prodId))
    },
    checkDefault () {
      var self = this
      var bSchema = this.schema.block
      var pSchema = this.schema.product
      // console.log(this.bActiveList)
      // clickBlock (curId, pre)
      for (var i = 0; i < this.bActiveList.length; i++) {
        var blocks = this.bActiveList[i]
        if (this.up) {
          var obj = {}
          for (var o = 0; o < self.curOrderInfo.blocks.length; o++) {
            var bItem = self.curOrderInfo.blocks[o].items
            for (var it = 0; it < bItem.length; it++) {
              var pId = bItem[it].product_id
              var amount = bItem[it].amount
              if (!obj[pId]) obj[pId] = true
              else self.$set(self.adjustSame, pId, false)
              for (var am = 1; am <= amount; am++) {
                if (self.curOrderInfo.blocks[o].block_id === blocks.block.product[bSchema.product_id] &&
                  self.checkDisableItem(parseInt(pId, 10), blocks.block.product[bSchema.product_id]) &&
                  self.checkDisableBlock(blocks.block.product[bSchema.product_id], self.currentProduct[pSchema.product_id])
                ) {
                  self.clickBlock(parseInt(pId, 10), blocks)
                }
              }
            }
          }
        } else {
          /*
          var aProd = Object.values(blocks.prod)
          var map = aProd.map(function (p, i) { return { index: i, sort: p.product[pSchema.sort] } })
          map.sort(function (a, b) { return a.sort - b.sort })
          var prodBlock = map.map(function (e) { return aProd[e.index] })
          */
          var aProd = Object.values(blocks.prod)
          var prodBlock = blocks.sortList.map(function (e) { return aProd[e.index] })
          var bIsMandatory = blocks.block.product[bSchema.is_mandatory]          // var prodBlock = blocks.prod
          // 檢查是否有default或是必選
          for (var index = 0; index < prodBlock.length; index++) {
            var key = prodBlock[index].product[pSchema.product_id]
            this.$set(this.adjustSame, key, true)
            if (blocks.prod[key].product[pSchema.is_default] &&
              self.checkDisableItem(parseInt(key, 10), blocks.block.product[pSchema.product_id]) &&
              self.checkDisableBlock(blocks.block.product[pSchema.product_id], self.currentProduct[pSchema.product_id])
            ) {
              self.clickBlock(parseInt(key, 10), blocks)
            } else if (blocks.prod[key].noChange &&
              self.checkDisableItem(parseInt(key, 10), blocks.block.product[pSchema.product_id]) &&
              self.checkDisableBlock(blocks.block.product[pSchema.product_id], self.currentProduct[pSchema.product_id])
            ) {
              self.clickBlock(parseInt(key, 10), blocks)
            } else if (!blocks.default && bIsMandatory) { // 確認哪個product是default
              blocks.default = key
              // self.clickBlock(parseInt(key, 10), blocks)
            }
            if (index + 1 === prodBlock.length && !blocks.activeList.length && blocks.default) {
              // 無default將選各選擇區第一個商品
              self.clickBlock(parseInt(blocks.default, 10), blocks)
            }
          }
          // 無default將選各選擇區第一個商品
          /*
          if (!blocks.activeList.length) {
            for (var index2 = 0; index2 < prodBlock.length; index2++) {
              var key2 = prodBlock[index2].product[pSchema.product_id]
              this.$set(this.adjustSame, key2, true)
              // console.log(blocks)
              // 預設選取第一個
              if (!blocks.activeList.length && blocks.block.product[bSchema.is_mandatory] &&
                blocks.prod[key2].product[pSchema.is_visible] && blocks.prod[key2].product[pSchema.is_enable] &&
                self.checkDisableItem(parseInt(key2, 10), blocks.block.product[pSchema.product_id]) &&
                self.checkDisableBlock(blocks.block.product[pSchema.product_id], self.currentProduct[pSchema.product_id])
              ) {
                self.clickBlock(parseInt(key2, 10), blocks)
                break
              }
            }
          }
          */
        }
      }
    },
    cheeseWording (pcName) {
      var name = pcName
      if (name) name = name.trim()
      switch (name) {
        case '日式燒肉堡':
        case '雙層起司雞腿堡':
        case '法式紅酒牛肉堡':
        case '墨西哥辣椒豬肉堡':
        case '墨西哥辣椒牛肉堡':
        case '豬肉起司瑪芬堡':
        case '豬肉瑪芬堡加蛋':
        case '雙層豬肉瑪芬堡':
        case '雙層豬肉瑪芬堡加蛋':
        case '義式磚壓-薑汁燒肉':
        case '口袋歐姆蛋-起士歐姆蛋':
        case '口袋歐姆蛋-肉醬歐姆蛋':
        case '口袋歐姆蛋-培根歐姆蛋':
        case '口袋歐姆蛋-蔬菜歐姆蛋':
        case '口袋歐姆蛋-鮪魚歐姆蛋':
        case '磚壓-法式紅酒牛肉':
        case '磚壓-墨西哥辣椒豬肉':
        case '磚壓-墨西哥辣椒牛肉':
          return true
        default: return false
      }
    },
    clickBlock (curId, pre) {
      // console.log(curId, pre)
      // var block = pre.block
      // var product = pre.prod
      this.choseCurProd = 0
      var self = this
      var curActive = false
      var pSchema = this.schema.product
      var bSchema = this.schema.block
      var curP = this.getProduct(curId)
      // 所選商品的價格
      if (!this.optionNumList[0][curId]) this.checkPrice(curP[pSchema.price], curP)
      else this.checkPrice()
      // var bSchema = this.schema.block
      for (var i = 0; i < this.bActiveList.length; i++) {
        var b = this.bActiveList[i]
        var pId = b.prod[curId]
        if (b.prod[curId]) {
          var active = pId.active
          // 1. 確認是否超過block數量
          var amount = 0
          var bAmount = self.optionNum[pId.product[pSchema.product_id]]
          if (bAmount) amount = bAmount
          var maxLimit = curP[pSchema.max_limit]
          // console.log(pre)
          var bMaxLimit = pre.block.product[bSchema.max_limit]
          if (maxLimit > bMaxLimit && bMaxLimit) maxLimit = bMaxLimit
          else if (bMaxLimit && !maxLimit) maxLimit = bMaxLimit

          amount++
          this.setOptionNum(curId, amount, curP)
          bAmount = amount

          if (bAmount > maxLimit && maxLimit) {
            // 非必選被重置
            if (!pId.noChange) {
              // 超過數量才取消active
              active = !active
              // 如果active = false
              if (!active) {
                amount = 0
                delete self.addPrice[pId.product[pSchema.product_id]]
                delete self.addPrices[pId.product[pSchema.product_id]]
                this.setOptionNum(curId, amount, curP)
              }
            } else {
              amount = 1
              this.setOptionNum(curId, amount, curP)
            }
          } else if (!active) {
            active = true
          }
          // 當必選、只留一個active
          // pre已出現過的productId
          if (pId.noChange || amount > 1) {
            // pre.activeList.splice(-1, 1)
            // console.log(pre.activeList)
            self.removeString(pre.activeList, curId)
          }
          self.checkPrice()
          curActive = active
          // 紀錄 active Id
          if (curActive) pre.block.pActive.push(curId)
          else pre.block.pActive = this.removeString(pre.block.pActive, curId)
          // 如果選取是product 就在商品內容秀出
          var prod = this.getProduct(curId)
          if (prod) {
            if (prod[pSchema.type] === 1) {
              this.pActiveList.find(function (o) {
                if (o.id === curId) {
                  if (curActive) {
                    o.show = true
                    pre.activeList.push(o.id)
                  } else {
                    o.show = false
                    self.optionCheck.id = curId
                    self.optionCheck.num++
                    self.removeString(pre.activeList, o.id)
                  }
                }
              })
            }
          }
          pId.active = active
        }
      }
      this.allProduct[curId] = true
      this.checkPackageLimit(pre, curP)
    },
    removeString (arr, str) {
      var what, ax
      var a = arguments
      var L = a.length
      while (L > 1 && arr.length) {
        what = a[--L]
        while ((ax = arr.indexOf(what)) !== -1) {
          arr.splice(ax, 1)
        }
      }
      return arr
    },
    checkPackageLimit (pre, curP) {
      var self = this
      var pSchema = this.schema.product
      // var removeId = pre.activeList[0]
      var removeIds = {}
      for (var i = 0; i < pre.activeList.length; i++) {
        if (i + 1 < pre.activeList.length) {
          var rKey = pre.activeList[i]
          if (!removeIds[rKey]) removeIds[rKey] = 1
          else removeIds[rKey] = removeIds[rKey] + 1
        }
      }
      // product也有個數
      var allActiveAmount = 0
      for (var a = 0; a < pre.activeList.length; a++) {
        allActiveAmount = allActiveAmount + self.optionNum[pre.activeList[a]]
      }
      // 超過上限
      if (allActiveAmount > pre.block.product[this.schema.block.max_limit] && pre.block.product[this.schema.block.max_limit]) {
        this.pActiveList.find(function (o) {
          if (typeof removeIds[o.id] !== 'undefined') {
            if (o.id !== curP[pSchema.product_id]) {
              pre.prod[o.id].active = false
              o.show = false
              self.removeString(pre.activeList, o.id)
              delete self.addPrice[o.id]
              delete self.addPrices[o.id]
              self.setOptionNum(o.id, 0, curP)
              self.checkPrice()
            } else if (o.id !== curP[pSchema.product_id] && pre.activeList < removeIds[o.id] + 1) {
              // 本身超過
              pre.prod[o.id].active = false
              o.show = false
              self.removeString(pre.activeList, o.id)
              delete self.addPrice[o.id]
              delete self.addPrices[o.id]
              self.setOptionNum(o.id, 0, curP)
              self.checkPrice()
            }
          }
        })
      }
    },
    clickProduct (prod) {
      var pSchema = this.schema.product
      this.packageLayer.show = false
      this.choseCurProd = prod[pSchema.product_id]
    },
    curProduct (prod) {
      var pSchema = this.schema.product
      if (prod[pSchema.product_id] === this.choseCurProd) return true
      return false
    },
    setOptionNum (id, count, curP) {
      // var pSchema = this.schema.product
      this.optionNum[id] = count
      this.optionNumList = [this.optionNum]
      // console.log(this.optionNumList)
    }
  },
  created () {
  },
  computed: {
    isUpList () {
      var list = {}
      for (var i = 0; i < this.curOrderInfo.blocks.length; i++) {
        var items = this.curOrderInfo.blocks[i].items
        for (var j = 0; j < items.length; j++) {
          if (!list[items[j].product_id]) list[items[j].product_id] = []
          list[items[j].product_id].push(items[j])
        }
      }
      return list
    },
    /*
    pContainerShow () {
      var pSchema = this.schema.product
      var pContainer = []
      for (var i = 0; i < this.getProductContainer.length; i++) {
        var pcDetail = this.getProductContainer[i]
        var pcId = pcDetail[pSchema.product_id]
        if (this.allProduct[pcId]) {
          for (var num = 0; num < this.optionNumList[0][pcId]; num++) {
            pContainer.push(pcDetail)
          }
        }
      }
      this.checkPrice()
      return pContainer
    },
    */
    getProductContainer () {
      this.clearOption()
      var pContainer = []
      var pSchema = this.schema.product
      var bSchema = this.schema.block
      if (Array.isArray(this.currentProduct)) {
        var pList = this.currentProduct[pSchema.product_list]
        var bList = this.currentProduct[pSchema.block_list]
        if (pList) {
          for (var i = 0; i < pList.length; i++) {
            var prod = this.getProduct(pList[i])
            if (prod) {
              if (prod[pSchema.type] === 1) { // product
                // is_enable and is_visible 者才能使用
                if (prod[pSchema.is_enable] && prod[pSchema.is_visible]) {
                  this.allProduct[pList[i]] = false
                  this.$set(this.adjustSame, pList[i], true)
                  if (this.up) {
                    /*
                    if (this.isUpList[pList[i]]) {
                      if (prod[pSchema.is_mandatory]) {
                        this.otherActiveList.push({id: prod[pSchema.product_id], active: true, show: true, noChange: true})
                      }
                      else {
                        this.otherActiveList.push({id: prod[pSchema.product_id], active: true, show: false, noChange: false})
                      }
                      this.pActiveList.push({id: prod[pSchema.product_id], active: false, show: true})
                      this.allProduct[pList[i]] = true
                    }
                    else {
                      this.pActiveList.push({id: prod[pSchema.product_id], active: false, show: false})
                      this.otherActiveList.push({id: prod[pSchema.product_id], active: false, show: true, noChange: false})
                      this.allProduct[pList[i]] = true
                    }
                    pContainer.push(prod)
                    */
                    if (prod[pSchema.is_mandatory]) {
                      this.pActiveList.push({id: prod[pSchema.product_id], active: false, show: true})
                      this.otherActiveList.push({id: prod[pSchema.product_id], active: true, show: true, noChange: true})
                      this.allProduct[pList[i]] = true
                    } else {
                      this.pActiveList.push({id: prod[pSchema.product_id], active: false, show: false})
                      this.otherActiveList.push({id: prod[pSchema.product_id], active: false, show: true, noChange: false})
                      this.allProduct[pList[i]] = true
                    }
                    pContainer.push(prod)
                  } else {
                    if (prod[pSchema.is_mandatory]) {
                      this.pActiveList.push({id: prod[pSchema.product_id], active: false, show: true})
                      this.otherActiveList.push({id: prod[pSchema.product_id], active: true, show: true, noChange: true})
                      this.allProduct[pList[i]] = true
                    } else {
                      this.pActiveList.push({id: prod[pSchema.product_id], active: false, show: false})
                      this.otherActiveList.push({id: prod[pSchema.product_id], active: false, show: true, noChange: false})
                      this.allProduct[pList[i]] = true
                    }
                    pContainer.push(prod)
                  }
                }
              } else if (prod[pSchema.type] === 3) { // package
                this.errorMenu = true
              }
              if (prod[pSchema.block_list].length) this.errorMenu = true
            }
          }
        }
        if (bList) {
          var bActiveList = []
          for (var j = 0; j < bList.length; j++) {
            // 將blockList下放入bActiveList
            // this.bActiveList.push({block: this.getBlock(bList[j])})
            var activeObj = {
              block: {
                pActive: [],
                product: this.getBlock(bList[j])
              },
              prod: {},
              activeList: [], // 已選取的選項
              sortList: []
            }
            // get product in block list
            var pIds = this.getBlock(bList[j])[bSchema.product_list]
            /*
            if (this.up) {
              var idsNew = []
              console.log(this.curOrderInfo.blocks[j])
              for (var item = 0; item < this.curOrderInfo.blocks[j].items.length; item++) idsNew.push(this.curOrderInfo.blocks[j].items[item].product_id)
              pIds = idsNew
            }
            */
            for (var k = 0; k < pIds.length; k++) {
              var bProd = this.getProduct(pIds[k])
              if (bProd[pSchema.type] === 1) { // product
                // is_enable and is_visible 者才能使用
                if (this.getProduct(pIds[k])[pSchema.is_enable] && this.getProduct(pIds[k])[pSchema.is_visible]) {
                  if (this.up) {
                    /*
                    if (this.isUpList[pIds[k]]) {
                      // 只有一項商品 && 如果block是必選 product永遠顯示
                      // product必選 product永遠顯示
                      if (((pIds.length === 1 && this.getBlock(bList[j])[bSchema.is_mandatory]) ||
                        bProd[pSchema.is_mandatory])
                      ) {
                        activeObj.prod[bProd[pSchema.product_id]] = {active: true, noChange: true, product: bProd}
                      }
                      else {
                        activeObj.prod[bProd[pSchema.product_id]] = {active: true, noChange: false, product: bProd}
                      }
                      // 選取
                      this.pActiveList.push({id: bProd[pSchema.product_id], active: true, show: true, disable: false})
                      activeObj.activeList.push(bProd[pSchema.product_id])
                      this.allProduct[pIds[k]] = true
                      this.setOptionNum(pIds[k], this.isUpList[pIds[k]].amount)
                    }
                    else {
                      activeObj.prod[bProd[pSchema.product_id]] = {active: false, noChange: false, product: bProd}
                      this.pActiveList.push({id: bProd[pSchema.product_id], active: false, show: false, disable: false})
                      this.allProduct[pIds[k]] = false
                    }
                    this.$set(this.adjustSame, pIds[k], true)
                    pContainer.push(bProd)
                    */
                    // 只有一項商品 && 如果block是必選 product永遠顯示
                    // product必選 product永遠顯示
                    if (((pIds.length === 1 && this.getBlock(bList[j])[bSchema.is_mandatory]) ||
                      bProd[pSchema.is_mandatory])
                    ) {
                      activeObj.prod[bProd[pSchema.product_id]] = {active: false, noChange: true, product: bProd}
                      if (this.checkDisableItem(bProd[pSchema.product_id], bList[j]) &&
                          this.checkDisableBlock(bList[j], this.currentProduct[pSchema.product_id])
                      ) {
                        this.pActiveList.push({id: bProd[pSchema.product_id], active: false, show: false, disable: false})
                        this.allProduct[pIds[k]] = true
                      } else {
                        this.pActiveList.push({id: bProd[pSchema.product_id], active: false, show: false, disable: false})
                        this.allProduct[pIds[k]] = false
                        this.show.cantOrder = true
                      }
                    } else {
                      activeObj.prod[bProd[pSchema.product_id]] = {active: false, noChange: false, product: bProd}
                      this.pActiveList.push({id: bProd[pSchema.product_id], active: false, show: false, disable: false})
                      this.allProduct[pIds[k]] = false
                    }
                    this.$set(this.adjustSame, pIds[k], true)
                    pContainer.push(bProd)
                  } else {
                    // 只有一項商品 && 如果block是必選 product永遠顯示
                    // product必選 product永遠顯示
                    if (((pIds.length === 1 && this.getBlock(bList[j])[bSchema.is_mandatory]) ||
                      bProd[pSchema.is_mandatory])
                    ) {
                      activeObj.prod[bProd[pSchema.product_id]] = {active: true, noChange: true, product: bProd}
                      if (this.checkDisableItem(bProd[pSchema.product_id], bList[j]) &&
                          this.checkDisableBlock(bList[j], this.currentProduct[pSchema.product_id])
                      ) {
                        this.pActiveList.push({id: bProd[pSchema.product_id], active: true, show: true, disable: false})
                        activeObj.activeList.push(bProd[pSchema.product_id])
                        this.allProduct[pIds[k]] = true
                      } else {
                        this.pActiveList.push({id: bProd[pSchema.product_id], active: false, show: false, disable: false})
                        this.allProduct[pIds[k]] = false
                        this.show.cantOrder = true
                      }
                    } else {
                      activeObj.prod[bProd[pSchema.product_id]] = {active: false, noChange: false, product: bProd}
                      this.pActiveList.push({id: bProd[pSchema.product_id], active: false, show: false, disable: false})
                      this.allProduct[pIds[k]] = false
                    }
                    this.$set(this.adjustSame, pIds[k], true)
                    pContainer.push(bProd)
                  }
                }
              } else if (bProd[pSchema.type] === 3) { // package
                this.errorMenu = true
              }
              // 看還有沒有下一層
              if (bProd[pSchema.block_list].length) this.errorMenu = true
              // 最後來組排序
              if (k + 1 === pIds.length) {
                var aProd = Object.values(activeObj.prod)
                var map = aProd.map(function (p, i) { return { index: i, sort: p.product[pSchema.sort] } })
                map.sort(function (a, b) { return a.sort - b.sort })
                activeObj.sortList = map
              }
            }
            bActiveList.push(activeObj)
            this.bActiveList = bActiveList
          }
        }
      }
      this.$nextTick(function () {
        this.checkDefault()
        // 點選最前面的product以供觀看
        if (!this.packageLayer.show && !this.choseCurProd) {
          for (var i = 0; i < pContainer.length; i++) {
            var prod = pContainer[i]
            if (this.allProduct[prod[pSchema.product_id]]) {
              this.clickProduct(prod)
              break
            }
          }
        }
      })
      return pContainer
    },
    showLgImg () {
      var layout = this.layout
      switch (layout) {
        case 1: return false
        case 2: return true
        case 3: return true
        case 4: return false
        default: return false
      }
    },
    storeStateName () {
      var state = this.storeState
      if (state === 0) return '門市未營業'
      else if (state === 1) return '門市籌備中'
      else if (state === 3) return '門市休息中'
      else if (state === 9) return '門市已歇業'
    },
    minCombinePrice () {
      var oSchema = this.schema.option
      var price = 0
      // 如果combine沒有價格，此為最小的combine組合價格
      for (var i in this.isOption.length) {
        price = price + this.isOption[i].option[oSchema.price]
      }
      return price
    },
    combinePrice () {
      var minPrice
      var self = this
      var priceCombine = []
      var priceList = []
      if (this.productCombineIds.length) {
        for (var i = 0; i < this.productCombineIds.length; i++) {
          var item
          var price = this.getCombine(this.productCombineIds[i])[this.schema.combine.price]
          if (price === null) {
            var edgeList = this.getCombine(this.productCombineIds[i])[this.schema.combine.edge_list]
            for (var key in edgeList) {
              this.parsePrice(edgeList[key])
              if (this.parsePrice(edgeList[key]).type === 'p') price = this.parsePrice(edgeList[key]).price
            }
            // combine 無價格 (price 已經為最低的組合價格，非該combine的價格)
            item = {price: price + self.minCombinePrice, combine: this.getCombine(this.productCombineIds[i])}
            priceCombine.push(item)
          } else {
            // combine 有價格
            item = {price: price, combine: this.getCombine(this.productCombineIds[i])}
            priceCombine.push(item)
          }
        }
      }
      // 如果combine有的有價格，有的沒有在此比較
      for (var o in priceCombine) {
        priceList.push(priceCombine[o].price)
      }
      minPrice = Math.min.apply(Math, priceList)
      return minPrice
    },
    isBigMilk () {
      var pSchema = this.schema.product
      var product = this.currentProduct
      var productName = product[pSchema.name]
      if (productName) {
        if (productName.trim() === '綠光純鮮奶家庭號') return true
      }
      return false
    }
  },
  mounted () {
    $('.q-numeric input').attr('maxlength', '2')
    $('.q-numeric input').attr('type', 'tel')
    $('.q-numeric input').keyup(function () {
      var e = $('.q-numeric input')
      if (isNaN(e.val())) {
        e.val(e.val().match(/[0-9]*/))
      }
    })
    // $('.q-numeric input').attr('disabled', true).css('-webkit-text-fill-color', '#333')
  },
  watch: {
    currentProduct () {
      this.clearOption()
      this.init()
      // this.addProduct()
    },
    cartMount () {
      this.setCartAmount(this.cartMount)
    },
    number () {
      if (!this.number) this.number = 1
    }
  }
}
</script>

<style lang="sass" scoped>
  $default-color: #00a8e8
  .order-item
    margin-bottom: 10px
  .q-numeric .input-group
    width: 105px !important
    padding: 4px 0px
    color: $default-color
  .numeric-left, .numeric-right, .q-numeric input
    border: solid 1px $default-color !important
    height: 28px !important
    padding: 3px 12px !important
  .numeric-left
    border-right: 0 !important
  .numeric-right
    border-left: 0 !important
  .q-numeric input
    width: 50px !important
  .btn-option:hover, .btn-option:focus, .btn-option:focus:active, .btn-option:active, .btn-option:hover:active
    background: #fff
    border: solid 1px $default-color
    color: #444
  .btn-option
    width: calc(100% / 3 - 10px)
    border-radius: 5px
    border: solid 1px $default-color
    margin: 5px
    background: #fff
  @media screen and (max-width: 444px)
    .btn-option
      width: calc(50% - 10px)
  @media screen and (max-width: 299px)
    .btn-option
      width: calc(100% - 10px)
  .q-numeric input
    border-radius: 0px
    -webkit-appearance: none
  #btn-update-cart
    width: calc(100% - 15px)
    padding-right: 10px
    padding-left: 10px
    max-width: 100%
    height: 61px
  .i-dropdown
    padding-left: 5px
    padding-right: 5px
    cursor: pointer
  .btn-blocked
    background-color: #fff !important
    color: #8E8E93 !important
    border: 1px solid #8E8E93 !important
  .btn-option
    line-height: 20px
  .no-style.q-input-field
    color: #333
  .btn-order-list
    text-align: center
  .btn-default[disabled]:hover, .btn-default[disabled]:focus, .btn-default[disabled]
    background-color: #fff !important
    color: #8E8E93 !important
    border: 1px solid #8E8E93 !important
    cursor: default !important
    pointer-events: none !important
  .adjust .btn-default[active], .adjust .btn-default.active
    background: #00a8e8 !important
    color: #fff !important
    border: 1px solid #00a8e8 !important
    box-shadow: none !important
  .modal-buttons.row
    margin-left: 0px !important
    margin-right: 0px !important
  .modal-header
    border-bottom: 0px
  @media (min-width: 601px)
    .btn-option
      width: calc(25% - 10px)
    .col-xs-6.btn-update-cart
      width: 100% !important
    @-moz-document url-prefix()
      .menu-model .modal-content div button:last-child, .menu-model .modal-content div button:last-child
        margin-bottom: 30px
  @media (max-width: 600px)
    @-moz-document url-prefix()
      .fixed-moz-b-150
        padding-bottom: 150px
</style>
<style lang="sass">
  .bg-pink
    background: #db4d6d !important
  .choose-block
    padding: 6px 10px
    border-radius: 4px
    background: #e9e9e9
    font-size: 14px
    font-weight: 500
    margin: 5px 10px 5px 0px
    .option-number
      background: #db4d6d
      position: absolute
      top: -7px
      right: -7px
      border-radius: 10px
      font-size: 12px
  .choose-block[blockActive], .choose-block[prodActive]
    background-color: #00a8e8 !important
    background: #00a8e8 !important
    color: #fff !important
  .form-title
    padding: 5px
    font-size: 16px
    text-align: center
    background: #333
    color: #fff
    font-weight: 600
    border-radius: 6px 6px 0px 0px
  .layout-line .btn-option
    width: 100%
    margin: 0
    text-align: left
    border-radius: 0px
    .option-name
      display: inline-block
    .option-price
      display: inline-block
    .option-number
      float: right
      background: white
      color: #00a8e8
      position: relative
      top: 0
      right: 0
</style>



// WEBPACK FOOTER //
// MenuPackageModalNew.vue?00f82649